import React from "react";

import { Skeleton } from "@common/skeleton";
import { Props } from "./types";
import styles from "./styles.scss";

function Loader(props: Props) {
  return (
    <ul className={styles.loader}>
      <div className={styles.item}>
        <Skeleton className={styles.name} />
        <Skeleton className={styles.checkbox} />
      </div>
      <div className={styles.item}>
        <Skeleton className={styles.name} />
        <Skeleton className={styles.checkbox} />
      </div>
      <div className={styles.item}>
        <Skeleton className={styles.name} />
        <Skeleton className={styles.checkbox} />
      </div>
      <div className={styles.item}>
        <Skeleton className={styles.name} />
        <Skeleton className={styles.checkbox} />
      </div>
      <div className={styles.item}>
        <Skeleton className={styles.name} />
        <Skeleton className={styles.checkbox} />
      </div>
      <div className={styles.item}>
        <Skeleton className={styles.name} />
        <Skeleton className={styles.checkbox} />
      </div>
    </ul>
  );
}

export { Loader };
